/**
 * The period the user last chose for each client, for this browser session. Kept in memory, and in sessionStorage so a
 * page reload keeps it; storage can be unavailable (private window, blocked), and then memory alone is used.
 */
const remembered = new Map<string, string>();
const storageKey = (clientId: string) => `ap.period.${clientId}`;

/** Remembers the period the user picked for this client; the period screens open on it next time. */
export function rememberPeriod(clientId: string | null | undefined, periodId: string | null | undefined): void {
  if (!clientId || !periodId) {
    return;
  }
  remembered.set(clientId, periodId);
  try {
    sessionStorage.setItem(storageKey(clientId), periodId);
  } catch {
    // Storage unavailable: the in-memory copy still serves this session.
  }
}

export function recallPeriod(clientId: string | null | undefined): string | null {
  if (!clientId) {
    return null;
  }
  const inMemory = remembered.get(clientId);
  if (inMemory) {
    return inMemory;
  }
  try {
    return sessionStorage.getItem(storageKey(clientId));
  } catch {
    return null;
  }
}

/** Forgets what was remembered (tests). */
export function forgetRememberedPeriods(): void {
  remembered.clear();
  try {
    sessionStorage.clear();
  } catch {
    // Nothing to clear.
  }
}
